import { render, staticRenderFns } from "./RateEditor.vue?vue&type=template&id=346def70&scoped=true"
import script from "./RateEditor.vue?vue&type=script&lang=js"
export * from "./RateEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346def70",
  null
  
)

export default component.exports